export const getHistoricalEntryUser = (name: string, value: string) => {
  let [firstname, surname, ...rest] = name.split(" ");
  if (rest.length > 0) {
    surname += " " + rest.join(" ");
  }
  return {
    ref: "",
    firstname,
    surname,
    userid: value,
  };
};
